export const skillsData = {
  Languages: ['JavaScript', 'TypeScript', 'Python'],
  Frontend: ['React.js', 'Next.js', 'Redux Toolkit', 'RTK Query', 'Apollo Client', 'Tailwind CSS'],
  'Backend & APIs': ['Node.js', 'Express.js', 'GraphQL', 'REST APIs', 'Flask'],
  'Databases & ORM': ['PostgreSQL', 'MySQL', 'MongoDB', 'Redis', 'Prisma ORM'],
  'Messaging & Architecture': ['RabbitMQ', 'BullMQ', 'Microservices', 'Event-Driven Architecture', 'Multi-Tenant SaaS', 'Distributed Systems'],
  'Real-Time & Integrations': ['WebSockets', 'Socket.IO', 'SSE', 'Twilio', 'Exotel', 'TCL', 'Microsoft Dynamics 365'],
  'AI & Voice': ['Google Gemini', 'MCP', 'Deepgram', 'ElevenLabs', 'AssemblyAI', 'Conversational AI', 'AI Voice Agents', 'OCR'],
  'Cloud & DevOps': ['Docker', 'AWS S3', 'Git', 'CI/CD', 'Turborepo'],
}
